import { FileClient } from "clients/rest";

export type B100063ExcelRequest = Partial<{
  tokuiCdFrom: string;
  tokuiCdTo: string;
  tokuishitenCdFrom: string;
  tokuishitenCdTo: string;
}>;

export const B100063GetExcel = (props: B100063ExcelRequest) => {
  return FileClient.get("b100063/get/excel", {
    params: props,
  });
};
